const traceUnknownPhoneNumber = {
  slug: 'trace-unknown-phone-number',
  title: 'How to trace an unknown phone number',
  description:
    'Step-by-step ways to investigate an unknown caller in Australia and internationally — legally and without compromising your privacy.',
  category: 'guides',
  guideType: 'guide',
  readMinutes: 7,
  partnerTip: 'none',
  relatedSlugs: [
    'reverse-phone-lookup-free-vs-paid',
    'understanding-caller-id-australia',
    'report-phone-scam-australia',
  ],
  sections: [
    {
      type: 'paragraph',
      text: 'Tracing a number means gathering clues about who is calling — not harassing the person behind it. Stay within the law and respect privacy.',
    },
    {
      type: 'heading',
      level: 2,
      text: '1. Record what you know',
    },
    {
      type: 'list',
      items: [
        'Date, time, and timezone of each call',
        'The exact number (including country code)',
        'Voicemail transcript and background noise',
        'Whether the same number called repeatedly',
      ],
    },
    {
      type: 'heading',
      level: 2,
      text: '2. Search on WhoDatNumber',
    },
    {
      type: 'paragraph',
      text: 'Community reports can reveal if others received similar calls, scam categories, and spam risk scores. Reports are moderated and community-sourced — use them as one signal, not proof.',
    },
    {
      type: 'lookupCta',
    },
    {
      type: 'heading',
      level: 2,
      text: '3. Use other public sources carefully',
    },
    {
      type: 'list',
      items: [
        'Search engines for business listings tied to the number',
        'Social media (only if profiles are public and relevant)',
        'Official white pages or business directories for your country',
      ],
    },
    {
      type: 'heading',
      level: 2,
      text: '4. Contact your carrier',
    },
    {
      type: 'paragraph',
      text: 'For harassment or threats, your telco may help with call trace features or blocking. They generally cannot give you the caller’s identity without legal process.',
    },
    {
      type: 'heading',
      level: 2,
      text: '5. Report scams to authorities',
    },
    {
      type: 'paragraph',
      text: 'If you suspect fraud, report to Scamwatch (Australia) or the equivalent in your country. See our regional reporting guide.',
    },
    {
      type: 'link',
      to: '/learn/regions/au',
      label: 'Report scams in Australia',
    },
    {
      type: 'warning',
      text: 'Do not use personal information you find to threaten, stalk, or doxx callers. Intercepting calls without consent is illegal in Australia.',
    },
  ],
};

export default traceUnknownPhoneNumber;

